import { render, staticRenderFns } from "./RecuperarCuenta.vue?vue&type=template&id=ca1b4486&scoped=true&lang=pug"
import script from "./RecuperarCuenta.vue?vue&type=script&lang=js"
export * from "./RecuperarCuenta.vue?vue&type=script&lang=js"
import style0 from "./RecuperarCuenta.vue?vue&type=style&index=0&id=ca1b4486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1b4486",
  null
  
)

export default component.exports